import { jsx as _jsx } from "react/jsx-runtime";
import { compose, getContext } from 'recompose';
import PropTypes from 'prop-types';
import { useSession } from 'frontend/js/modules/infra/session';
import { ListLayout } from './list-layout';
import { useBreakpoints } from '../../../../infra/dls/hooks/use-get-breakpoints';
import { getUrlPrefixFromView, useNavigate } from '../../../../infra/routing';
export var ListLayoutContainer = function (_a) {
    var children = _a.children, toggleSidebar = _a.toggleSidebar;
    var isTabletOrSmaller = useBreakpoints().isTabletOrSmaller;
    var navigate = useNavigate();
    var session = useSession().data;
    var urlPrefix = getUrlPrefixFromView(session.view);
    var handleViewChange = function (view) {
        if (view === 'list') {
            navigate("".concat(urlPrefix, "/engagement"));
        }
        if (view === 'automated') {
            navigate("".concat(urlPrefix, "/engagement/automated"));
        }
    };
    var handleAdd = function () {
        // TODO: Implement add functionality
    };
    return (_jsx(ListLayout, { isTabletOrSmaller: isTabletOrSmaller, toggleSidebar: toggleSidebar, onViewChange: handleViewChange, onAdd: handleAdd, children: children }));
};
export var EnhancedListLayoutContainer = compose(getContext({
    toggleSidebar: PropTypes.func.isRequired,
}))(ListLayoutContainer);
